namespace TabAurous.Administration {
    export interface SendCampaignDetailsRow {
        ScheduleDetailsId?: number;
        ScheduleId?: number;
        PartyId?: number;
    }

    export namespace SendCampaignDetailsRow {
        export const idProperty = 'ScheduleDetailsId';
        export const localTextPrefix = 'Administration.SendCampaignDetails';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ScheduleDetailsId = "ScheduleDetailsId",
            ScheduleId = "ScheduleId",
            PartyId = "PartyId"
        }
    }
}
